import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

export default class AccountCancelledRedirectRoute extends Route {
  @service('stripev3') stripe;

  beforeModel() {
    return this.stripe.load();
  }

  redirect() {
    this.router.replaceWith('authenticated.account_canceled');
  }
}
